import { CancellationError } from '../cancellation';
import ImmediatePromise from 'engine/ImmediatePromise/ImmediatePromise';

export default function runAsync<T>(
	fn: () => Generator<unknown, T | PromiseLike<T> | ImmediatePromise<T>, any>,
	that: any
): Promise<Awaited<T>> {
	const gen = fn.call(that) as Generator<unknown, T | PromiseLike<Awaited<T>> | ImmediatePromise<Awaited<T>>, any>;

	const promise = new Promise((res, rej) => {
		const step = (v: unknown, rejected: boolean) => {
			try {
				const { done, value } = rejected ? gen.throw(v) : gen.next(v);

				if (done) {
					res(value instanceof ImmediatePromise
						? value.getOrdinaryPromise()
						: value as Awaited<T> | PromiseLike<Awaited<T>>);
				} else {
					const promise = value instanceof ImmediatePromise
						? value
						: Promise.resolve(value);
					promise.then(
						v => step(v, false),
						v => step(v, true),
					);
				}
			} catch(e) {
				rej(e);
			}
		}

		step(undefined, false);
	});

	// workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=1642147
	// search this url to find other spots
	promise.catch(e => {
		if(e instanceof CancellationError && e.context === that) {
			return null;
		}
		throw e;
	});

	return promise as Promise<Awaited<T>>;
}